import React, { useEffect, useReducer } from 'react'
import { todoReducer } from './TodoAppScreenComponents/todoReducer'
import { useForm } from '../../Hooks/useForm'
import { TodoList } from './TodoAppScreenComponents/TodoList'

import '../../styles/todoAppScreen.css'

const init = () => {
    return JSON.parse(localStorage.getItem( 'todos')) || [];
}

export const TodoAppScreen = () => {

    const [ todos, dispatch ] = useReducer(todoReducer, [], init)

    const [ { description }, handLeInputChange, reset ] = useForm({
        description: '',

    });

    useEffect(() => {
       localStorage.setItem('todos', JSON.stringify( todos ) )
    }, [ todos ])

    const handLeDelete = ( todoId ) => {

        const action = {
            type: 'delete',
            payload: todoId,
        }

        dispatch( action )

    }

    const handLeToggle = ( todoId ) => {

        dispatch({
            type: 'toggle',
            payload: todoId,
        })

    }

    const handLeSubmit = (e) => {
        e.preventDefault();

        if(description.trim().length <= 1){
            return;
        }
        
        const newTodo = {
            id: new Date().getTime(),
            desc: description,
            done: false,
        };

        const action ={
            type: 'add',
            payload: newTodo,

        }

        dispatch( action );
        reset();
        
    }

    return (
        <div className="todoapp">
            <h1>TodoApp ( { todos.length } )</h1>
            <hr />

                <div className="row">
                    <div className="col-7">
                    <TodoList todos={ todos }
                    handLeToggle={ handLeToggle }
                    handLeDelete={ handLeDelete }
                    />
                    </div>
                    <div 
                    className="col-5"
                    >
                        <h4 className="todoapp__title4">Agregar Todo</h4>
                        <hr />

                        <form onSubmit={ handLeSubmit }>

                            <input
                            type="text"
                            name="description"
                            className="form-control"
                            placeholder=""
                            autoComplete="off"
                            onChange={ handLeInputChange }
                            value={ description }
                            >

                            </input>

                            <button
                                type="submit"
                                className="btn btn-primary mt-1 btn-block"
                            >
                                Agregar
                            </button>

                        </form>

                    </div>
                
                </div>

           <div className="footer">
               <h5>Realizado con useReducer y localStorage. Puedes hacer click para marcar como completado </h5>
           </div>
        </div>
    )
}
